// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2qx3g","search":"Settings_search__FKYTz","filter":"Settings_filter__17APz"};